var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "popup-form"
  }, [_c('div', {
    staticClass: "content-form-popup"
  }, [_c('div', {
    staticClass: "header-text"
  }, [_c('div', {
    staticClass: "back-button-wrapper pointer",
    on: {
      "click": _vm.closePopup
    }
  }, [_c('img', {
    staticClass: "nav-link-icon filter-primary",
    attrs: {
      "src": require("@/images/modal-close.svg"),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "blackcolor pop-800"
  }, [_vm._v("Fixácia")]), _vm.changed ? _c('button', {
    staticClass: "w-button saveformBtn",
    on: {
      "click": _vm.saveApplicationData
    }
  }, [_vm._v(" Uložiť ")]) : _vm._e()]), _vm._l(_vm.rok, function (year) {
    return _c('fixation-item-holder', {
      key: year,
      attrs: {
        "title": 'ROK',
        "year": year,
        "preselected": _vm.fixationSelected
      },
      on: {
        "fixation-toggle": function fixationToggle($event) {
          return _vm.handleFixationYearChange($event);
        }
      }
    });
  }), _vm._l(_vm.roky, function (year) {
    return _c('fixation-item-holder', {
      key: year,
      attrs: {
        "title": 'ROKY',
        "year": year,
        "preselected": _vm.fixationSelected
      },
      on: {
        "fixation-toggle": function fixationToggle($event) {
          return _vm.handleFixationYearChange($event);
        }
      }
    });
  }), _vm._l(_vm.rokov, function (year) {
    return _c('fixation-item-holder', {
      key: year,
      attrs: {
        "title": 'ROKOV',
        "year": year,
        "preselected": _vm.fixationSelected
      },
      on: {
        "fixation-toggle": function fixationToggle($event) {
          return _vm.handleFixationYearChange($event);
        }
      }
    });
  })], 2)]);

}
var staticRenderFns = []

export { render, staticRenderFns }